module.exports = __webpack_public_path__ + "static/media/comment-alt-edit.c529d070.svg";